"use client";

import { TAGS } from "@raumagarn/formatters";
import { useClearRefinements, useCurrentRefinements } from "react-instantsearch";
import { Cross } from "~/components/icons/Cross";
import styles from "~/features/products/ProductListingPage/ProductListingPage.module.css";
import { textconfig } from "~/textconfig";

const getReadableLabel = (refinement: { attribute: string; label: string }) => {
	if (refinement.attribute === "freeRecipe") {
		return TAGS.free;
	}

	if (refinement.attribute === "outlet") {
		return TAGS.outlet;
	}

	if (refinement.attribute === "archive") {
		return TAGS.archive;
	}

	if (refinement.label === "topDown") {
		return textconfig.plp.filtersLabels.topDown;
	}

	if (refinement.label === "bottomUp") {
		return textconfig.plp.filtersLabels.bottomUp;
	}

	return refinement.label;
};

export const AlgoliaRefinementTags = () => {
	const { items, refine } = useCurrentRefinements();
	const { refine: clearAllRefinements } = useClearRefinements();

	const visibleRefinements = items.filter((item) => item.attribute !== "productType");

	if (!visibleRefinements.length) return null;

	return (
		<div className={styles.tags__wrapper}>
			{visibleRefinements.map((item) =>
				item.refinements.map((refinement) => (
					<button
						key={`${item.attribute}-${refinement.value}`}
						type="button"
						className="tag"
						onClick={() => refine(refinement)}
					>
						{getReadableLabel(refinement)} <Cross />
					</button>
				)),
			)}
			<button type="button" className="transparent small" onClick={clearAllRefinements}>
				Nullstill
			</button>
		</div>
	);
};
